import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
	reducerPath: "authApi",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_SERVER_URL}api/`,
		prepareHeaders: (headers, { getState }) => {
			const token = getState().auth.token;
			if (token) {
				headers.set("authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),
	endpoints: (builder) => ({
		login: builder.mutation({
			query: (body) => ({
				url: `auth/login`,
				method: "POST",
				body,
			}),
			transformResponse: (response) => response,
		}),
		getUser: builder.query({
			query: ({token}) => ({
				url: `auth/getUser/${token}`,
				method: "GET",
			}),
			transformResponse: (response) => response,
		}),
	}),
});

export const { useLoginMutation, useGetUserQuery } = authApi;
